import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import './plans.css'
import Basic from './Basic'
import AllFeatures from './AllFeatures'
import { withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import getLoginId from '../../../utils/getLoginId'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import ConfirmationalDialog from '../../common/ConfirmationDialog'

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  italicizedText: {
    fontStyle: 'italic'
  },
  fullWidth: {
    width: '100%'
  }
})

const GET_ALL_FEATURES = gql`
  query {
    features: allFeatures(status: 1) {
      id
      featureName
      costPerAssetPerMonth
      featureDescription
    }
  }
`
const GET_FEATURE_BY_PLAN = gql`
  query getPlans($planid: Int!) {
    getPlans(id: $planid) {
      id
      planName
      description
      featureList {
        id
        featureName
        costPerAssetPerMonth
        featureDescription
      }
    }
  }
`
const UPDATE_PLANS = gql`
  mutation updatePlans(
    $id: Int!
    $planName: String!
    $description: String!
    $featureList: String!
    $costPerAsset: Int!
    $partnerLoginId: Int!
    $status: Int!
  ) {
    updatePlans(
      id: $id
      planName: $planName
      description: $description
      featureList: $featureList
      costPerAsset: $costPerAsset
      partnerLoginId: $partnerLoginId
      status: $status
    )
  }
`
class editPlan extends Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
      isSpeedLimitValid: true,
      planName: '',
      description: '',
      tempState: {},
      plan: '',
      featuresList: '',
      tempPrice: {},
      terms: false,
      message: '',
      isPlanValid: true,

      // basic: '',
      partnerLoginId: getLoginId()
    }
  }

  handleChangeChecked = (name, price) => event => {
    // console.log(name, event.target.value, event.target.checked)
    let tempState = this.state.tempState
    let a = { ...tempState }
    let p = { ...this.state.tempPrice }
    // console.log('mee', a)
    if (event.target.checked === true) {
      this.setState({
        [name]: event.target.checked
        // message: 'Got it'
      })
      a[name] = true
      p[name] = price
    }

    if (event.target.checked === false) {
      this.setState({
        [name]: event.target.checked
        // message: 'Accept Terms'
      })
      a[name] = false
      p[name] = 0
    }
    this.setState({
      tempState: a,
      tempPrice: p
    })
    // console.log('lastS', this.state.tempState)
    // console.log('lastP', this.state.tempPrice)
    let tempcost = 0
    // console.log('ll', this.state.tempPrice[1])
    Object.values(this.state.tempPrice).map(
      price => (tempcost = tempcost + price)
    )
    this.setState({ cost: tempcost })
    // console.log('last=', a)
    // console.log('2p', this.state.cost)
  }
  handleTermsChangeChecked = name => event => {
    // console.log('terms1', this.state.terms)
    // console.log('tt', event.target.checked)
    let val
    if (event.target.checked) {
      val = true
    } else {
      val = false
    }
    this.setState({ [name]: event.target.checked, terms: val })
    // console.log('terms2', this.state.terms)
  }

  handleInputChange = key => e => {
    this.setState({ [key]: e.target.value })
    // if (e.target.value != '') {
    // }
  }

  handleChangePlan = event => {
    this.setState({ clientPlan: event.target.value })
  }

  handleChange = async tempState => {
    // console.log('Plan is ', event.target.value)
    const { data } = await this.props.client.query({
      query: GET_FEATURE_BY_PLAN,
      fetchPolicy: 'network-only',
      variables: { planid: parseInt(this.props.match.params.planId, 10) }
    })

    let a = { ...tempState }
    let p = { ...this.state.tempPrice }
    // console.log('data===', data.getPlans.featureList)

    this.state.featuresList.features.forEach(allFeatures => {
      a[allFeatures.id] = false
      p[allFeatures.id] = 0
    })
    data.getPlans.featureList.forEach(defaultFeature => {
      a[defaultFeature.id] = true
      p[defaultFeature.id] = defaultFeature.costPerAssetPerMonth
      //  console.log('uuuu', this.state.tempState[[defaultFeature.id]])
    })
    this.setState({
      id: data.getPlans.id,
      planName: data.getPlans.planName,
      description: data.getPlans.description,
      plan: data.getPlans.id,
      //  defaultFeatures: data,
      tempState: a,
      tempPrice: p
    })
    let tempcost = 0
    // console.log('ll', this.state.tempPrice[1])
    Object.values(this.state.tempPrice).map(
      price => (tempcost = tempcost + price)
    )
    this.setState({ cost: tempcost })
    // console.log('2p', this.state.cost)
  }

  handleCancelClick = e => {
    this.setState({ isCancelConfDialogOpen: true })
  }

  handleSubmitClick = e => {
    this.setState({ isSubmitConfDialogOpen: true })
  }

  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleSaveNegativeResponse = e => {
    this.setState({ isSubmitConfDialogOpen: false })
  }

  cancelNewPlan = e => {
    this.props.history.goBack()
  }

  handleSubmit = async event => {
    let checkedlist = []
    Object.keys(this.state.tempState).forEach(price => {
      if (this.state.tempState[price]) {
        const temp = {}
        temp['featureId'] = price
        checkedlist.push(temp)
      }
    })

    // this.setState.isFeatureChanged =
    //   JSON.stringify(initial) === JSON.stringify(final)

    let selCost = 0
    if (this.state.featuresList) {
      this.state.featuresList.features.map(
        featuresList =>
          (selCost = selCost + this.state.tempPrice[featuresList.id])
      )
    }
    if (this.state.tempState[8] && this.state.tempState[24]) {
      this.props.openSnackbar('Select only one Google Map or Open Street map')
    } else if (
      this.state.terms === true &&
      this.state.planName !== '' &&
      this.state.description !== '' &&
      checkedlist.length !== 0
    ) {
      const { data, errors } = await this.props.client.mutate({
        mutation: UPDATE_PLANS,
        variables: {
          id: parseInt(this.state.id, 10),
          partnerLoginId: getLoginId(),
          planName: this.state.planName,
          description: this.state.description,
          featureList: JSON.stringify(checkedlist),
          costPerAsset: parseInt(selCost, 10),
          status: 1
        },
        errorPolicy: 'all'
      })
      if (data) {
        this.setState({
          id: '',
          planName: '',
          description: '',
          featureList: '',
          costPerAsset: ''
        })
        this.props.openSnackbar('Plan Edited Sucessfully')
        this.props.history.goBack()
      } else if (errors) {
        this.props.openSnackbar(errors[0].message)
      }
    } else if (
      this.state.terms === false &&
      this.state.planName !== '' &&
      this.state.description !== ''
    ) {
      this.props.openSnackbar('Accept terms and conditions')
    } else if (this.state.planName === '') {
      this.props.openSnackbar('Plan Name field should not be empty')
    } else if (this.state.description === '') {
      this.props.openSnackbar('Description field should not be empty')
    } else if (this.state.isPlanValid === false) {
      this.props.openSnackbar('Plan Name should be 4 to 20 Letters')
    } else {
      this.props.openSnackbar('Select Atleast One Feature')
    }
    // if (isFeatureChanged === true) {
    //   console.log('featurechanges aa gaya===', isFeatureChanged)
    //   this.props.openSnackbar('Invalid Plan Name')
    // }
  }

  getAllFeatures = async () => {
    const response = await this.props.client.query({
      query: GET_ALL_FEATURES,
      fetchPolicy: 'network-only'
    })
    if (response.data && response.data.features) {
      const tempState = {}
      const tempPrice = {}
      response.data.features.forEach(feature => {
        tempState[feature.id] = false
        tempPrice[feature.id] = 0
      })
      this.setState({
        tempState: tempState,
        featuresList: response.data,
        tempPrice: tempPrice
      })
      let tempcost = 0
      response.data.features.map(
        featuresList =>
          (tempcost = tempcost + this.state.tempPrice[featuresList.id])
      )
      this.setState({ cost: tempcost })
    }
  }

  checkPlanValidity = async () => {
    const regex = new RegExp(/^[a-zA-Z0-9\s-_"]{4,20}$/)
    this.setState({
      isPlanValid: regex.test(this.state.planName)
    })
  }

  async componentDidMount() {
    await this.getAllFeatures()
    this.handleChange(this.state.tempState)
  }
  render() {
    const { classes } = this.props

    return (
      <div className={classes.root}>
        <ConfirmationalDialog
          isDialogOpen={this.state.isSubmitConfDialogOpen}
          dialogMessage={'Are you sure you want to Save this Edited Plan?'}
          negativeResponseHandler={this.handleSaveNegativeResponse}
          positiveResponseHandler={this.handleSubmit}
        />
        <ConfirmationalDialog
          isDialogOpen={this.state.isCancelConfDialogOpen}
          dialogMessage={'Are you sure you want to Cancel Edit Plan ?'}
          negativeResponseHandler={this.handleCancelNegativeResponse}
          positiveResponseHandler={this.cancelNewPlan}
        />
        <Grid container spacing={16}>
          <Grid item xs={12}>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={this.handleCancelClick}
            >
              <ArrowBackIcon />
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Edit Plan"
                subheader="All fields marked with (*) are mandatory"
                subheaderTypographyProps={{
                  className: classes.italicizedText
                }}
              />
              <CardContent>
                <Grid container spacing={16}>
                  <Grid item xs={12}>
                    <Grid container spacing={8}>
                      <Grid item xs={12}>
                        <FormControl className={classes.fullWidth}>
                          <FormGroup>
                            <TextField
                              fullWidth
                              id="planName"
                              name="planName"
                              margin="none"
                              label="Plan Name"
                              type="text"
                              // type="Multi-line"
                              value={this.state.planName}
                              required
                              onChange={this.handleInputChange('planName')}
                              error={!this.state.isSpeedLimitValid}
                              onBlur={this.checkSpeedLimitValidity}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isSpeedLimitValid
                                ? 'Invalid Speed Limit'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl className={classes.fullWidth}>
                          <FormGroup>
                            <TextField
                              fullWidth
                              id="description"
                              name="description"
                              margin="none"
                              label="Description"
                              type="text"
                              value={this.state.description}
                              required
                              onChange={this.handleInputChange('description')}
                              error={!this.state.isSpeedLimitValid}
                              onBlur={this.checkSpeedLimitValidity}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isSpeedLimitValid
                                ? 'Invalid Speed Limit'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container spacing={8}>
                      <Grid item xs={12}>
                        <AllFeatures
                          allFeaturesList={this.state.featuresList}
                          tempState={this.state.tempState}
                          handleChangeChecked={this.handleChangeChecked}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container spacing={8}>
                      <Grid item xs={12}>
                        <Basic
                          allFeaturesList={this.state.featuresList}
                          tempPrice={this.state.tempPrice}
                          terms={this.state.terms}
                          message={this.state.message}
                          plan={this.state.plan}
                          description={this.state.description}
                          handleSubmit={this.handleSubmitClick}
                          handleCancel={this.handleCancelClick}
                          handleTermsChangeChecked={
                            this.handleTermsChangeChecked
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(withApollo(withSharedSnackbar(editPlan)))



// WEBPACK FOOTER //
// ./src/components/Pages/Plans/EditPlan.jsx